<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import EssayModal from "@/components/modals/essay-modal.vue";
import EssayViewModal from "@/components/modals/essay-view-modal.vue";
import EssayActionModal from "@/components/modals/essay-actions-modal.vue";
import EssayPdfViewModal from "@/components/modals/essay-pdf-view-modal.vue";
import ProjectSelectModal from "@/components/modals/project-select-modal.vue";
import api from "@/helpers/api-rest/api.js";
import store from "@/state/store";
import Swal from "sweetalert2";
import statusHelper from "@/helpers/general/status.js";
import format from "date-fns/format";

export default {
  page: {
    title: "Mis Proyectos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    EssayModal,
    EssayViewModal,
    EssayActionModal,
    EssayPdfViewModal,
    ProjectSelectModal,
  },
  data() {
    return {
      title: "Mis Proyectos",
      essays: [],
      isBusy: false,
      filter: "",
      essayModalId: "ModalEssay",
      essayViewModalId: "ModalViewEssay",
      essayActionModalId: "ModalActionEssay",
      essayEdit: undefined,
      isModalActive: false,
      currentStep: 0,
      actionType: "",
      essayId: null,
      action: {},
      essayURL: "",
      statusHelper,
      selectedProjectId: null,
      currentPage: 1,
      perPage: 12,
      pageOptions: [12, 24, 48],
    };
  },
  computed: {
    filteredEssays() {
      if (!this.filter) return this.essays;
      const searchTerm = this.filter.toLowerCase();
      return this.essays.filter(
        (essay) =>
          essay.name?.toLowerCase().includes(searchTerm) ||
          essay.project?.name?.toLowerCase().includes(searchTerm) ||
          essay.created_by?.name?.toLowerCase().includes(searchTerm)
      );
    },
    paginatedEssays() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredEssays.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredEssays.length / this.perPage);
    },
  },
  methods: {
    showElement(roleId = [], show = true, showEdit = true) {
      const role = store.getters["auth/role"];
      return roleId.includes(role.id) && show && showEdit;
    },
    isCenterCollaborator(essay) {
      return essay?.access?.context === "center_collaborator";
    },
    isEssayInDraft(essay) {
      // essay_statuses: 1 = En redacción
      return Number(essay?.essay_status_id) === 1;
    },
    canCenterCollaboratorOpenEssay(essay) {
      return this.isCenterCollaborator(essay) && !this.isEssayInDraft(essay);
    },
    async loadEssays() {
      this.isBusy = true;
      try {
        // Load essays without project_id filter to get all coordinator essays
        const apiEndpoint = `/api/v1/essays`;
        const response = await api.get({ url: apiEndpoint });
        const data = response?.data?.data.map((essay) => ({
          ...essay,
          createdBy: essay.created_by?.name || "N/A",
          essayStatus: essay.essay_status?.name || "N/A",
          accessContextLabel:
            essay.access?.context === 'center_collaborator'
              ? 'Centro'
              : essay.access?.context === 'owner'
              ? 'Coordinador'
              : essay.access?.context === 'admin'
              ? 'Admin'
              : null,
          course_ids: essay.courses?.map((item) => item.id) || [],
          projectName: essay.project?.name || "Sin proyecto",
        }));

        this.essays = data;
      } catch (error) {
        console.error("Error loading essays:", error);
        this.essays = [];
      } finally {
        this.isBusy = false;
      }
    },
    addEssay() {
      // Show project selection modal first
      this.$bvModal.show("ModalProjectSelect");
    },
    onProjectSelected(project) {
      this.selectedProjectId = project.id;
      // Initialize essay with selected project
      const currentDate = new Date().toISOString().slice(0, 10);
      this.essayEdit = {
        id: null,
        name: "",
        description: "",
        antecedentes: "",
        arte_status: "",
        type: null,
        current_step: 0,
        courses: [],
        course_ids: [],
        project_id: project.id,
        essay_coordinator: {
          center_id: null,
          document_name: null,
          document_path: null,
          essay_professorates: [],
        },
        targets: [
          {
            title: "",
            description: "",
            target_results: [
              {
                id: "",
                target_id: "",
                title: "",
                description: "",
                quantitative_qualitative_assessment: "",
                products_realized: "",
                educational_community_impact: "",
                transferability_to_other_centers: "",
                other_expected_results: "",
                communications_conferences: "",
                exploitation_licenses_patents: "",
                agreements_networks_proposals: "",
              },
            ],
          },
        ],
        actions: [
          {
            id: "",
            name: "",
            descriptions: "",
            init_date: currentDate,
            end_date: currentDate,
            responsables: "",
            risks: "",
            contingency_plan: "",
            essay_id: null,
            education_activities: [],
            economic_forecats: [],
          },
        ],
      };
      this.$bvModal.show(this.essayModalId);
      this.isModalActive = true;
      this.currentStep = 0;
    },
    editEssay(essay) {
      if (!essay.essay_coordinator) {
        essay.essay_coordinator = {
          center_id: null,
          essay_professorates: [],
          document_name: "",
        };
      }

      if (!essay.targets) {
        essay.targets = [];
      }

      essay.targets = essay.targets.map((target) => ({
        ...target,
        title: target.title || "",
        target_results: target.target_results || [],
        target_achievements: target.target_achievements || [],
      }));

      this.essayEdit = essay;
      this.selectedProjectId = essay.project_id;
      this.$bvModal.show(this.essayModalId);
      this.isModalActive = true;
      this.currentStep =
        essay.current_step !== null && essay.current_step !== undefined
          ? Number(essay.current_step)
          : 0;
    },
    viewEssay(essay) {
      this.essayEdit = essay;
      this.$bvModal.show(this.essayViewModalId);
    },
    handleModalClose() {
      this.$bvModal.hide(this.essayModalId);
      this.loadEssays();
      this.isModalActive = false;
      this.selectedProjectId = null;
    },
    handleModalAction(actionType, essay) {
      this.$bvModal.hide(this.essayViewModalId);
      this.action = {
        description: "",
        essay_id: null,
      };
      this.actionType = actionType;
      this.essayId = essay;
      this.$bvModal.show(this.essayActionModalId);
    },
    successAction() {
      this.loadEssays();
    },
    setEssay(essay) {
      this.essayEdit = essay;
    },
    toggleDelete(essayId) {
      Swal.fire({
        title: "¿Estás seguro que quieres eliminar este proyecto?",
        text: "Una vez eliminado no podrá recuperarlo",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sí, borrar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          const apiEndpoint = `/api/v1/essays/${essayId}`;
          api.delete({ url: apiEndpoint }).then((response) => {
            Swal.fire({
              title: "Solicitud completada",
              text: response?.data?.message,
              icon: "success",
              showConfirmButton: true,
              timer: 2000,
            });
            this.loadEssays();
          });
        }
      });
    },
    getStatusVariant(statusId) {
      if (statusId === 3) return "warning";
      if (statusId === 4) return "danger";
      return "info";
    },
    getStepVariant(step) {
      return step === 3 ? "success" : "warning";
    },
    getStepText(step) {
      return step === 3
        ? "Finalizado"
        : `Incompleto (Paso ${step + 1})`;
    },
    formatDate(date) {
      if (!date) return "N/A";
      return format(new Date(date), "dd/MM/yyyy");
    },
    goToPage(page) {
      this.currentPage = page;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  mounted() {
    this.loadEssays();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title">
      <template v-slot:header-button>
        <button
          v-if="showElement([3])"
          @click="addEssay()"
          class="btn btn-success"
        >
          <i class="fa fa-plus"></i> Redactar proyecto
        </button>
      </template>
    </PageHeader>

    <!-- Modals -->
    <ProjectSelectModal @project-selected="onProjectSelected" />
    <EssayModal
      :id="essayModalId"
      :project_id="selectedProjectId"
      :essay="essayEdit"
      :isActive="isModalActive"
      :currentStep="currentStep"
      @updatedEssay="setEssay"
      @success="loadEssays"
      @close="handleModalClose"
    />
    <EssayViewModal
      :id="essayViewModalId"
      :essay="essayEdit"
      @open-action-modal="handleModalAction"
    />
    <EssayActionModal
      :id="essayActionModalId"
      :actionType="actionType"
      :essayId="essayId"
      :action="action"
      @success="successAction"
    />
    <EssayPdfViewModal :url="essayURL" />

    <!-- Main Content -->
    <div class="row">
      <div class="col-12">
        <!-- Search and Filters -->
        <div class="card mb-4">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="search-box">
                  <div class="position-relative">
                    <input
                      v-model="filter"
                      type="text"
                      class="form-control"
                      placeholder="Buscar por nombre, convocatoria o usuario..."
                    />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-6 text-md-right mt-3 mt-md-0">
                <label for="per-page-select-essays" class="d-inline-flex align-items-center">
                  Mostrar&nbsp;
                  <b-form-select
                    id="per-page-select-essays"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                    class="d-inline-block"
                    style="width: auto"
                  ></b-form-select>
                  &nbsp;por página
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading State -->
        <div v-if="isBusy" class="text-center p-5">
          <b-spinner variant="primary" class="mb-3"></b-spinner>
          <p class="text-muted">Cargando proyectos...</p>
        </div>

        <!-- Empty State -->
        <div
          v-else-if="filteredEssays.length === 0"
          class="card"
        >
          <div class="card-body text-center p-5">
            <i class="ri-file-list-line font-size-48 text-muted mb-3"></i>
            <h5 class="text-muted">
              {{ filter ? "No se encontraron resultados" : "No hay proyectos" }}
            </h5>
            <p class="text-muted" :class="!filter ? 'mb-3' : 'mb-0'">
              {{
                filter
                  ? "Intenta con otros términos de búsqueda"
                  : "Comienza creando tu primer proyecto"
              }}
            </p>
            <div v-if="showElement([3]) && !filter">
              <a
                href="javascript:void(0);"
                class="text-success"
                @click="addEssay()"
              >
                <i class="mdi mdi-plus-circle font-size-18"></i>
                Redactar proyecto
              </a>
            </div>
          </div>
        </div>

        <!-- Essays Cards Grid -->
        <div v-else>
          <div class="row">
            <div
              v-for="essay in paginatedEssays"
              :key="essay.id"
              class="col-lg-4 col-md-6 mb-4"
            >
              <div class="essay-card card h-100 shadow-sm d-flex flex-column">
                <div class="card-body flex-grow-1">
                  <!-- Header: Title and Status Badge -->
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <h5
                      class="card-title mb-0 flex-grow-1 pr-2 essay-title"
                      v-b-tooltip.hover
                      :title="essay.name"
                    >
                      {{ essay.name }}
                    </h5>
                    <div class="d-flex flex-column align-items-end flex-shrink-0">
                      <b-badge
                        pill
                        :variant="getStatusVariant(essay.essay_status_id)"
                        class="font-size-11"
                      >
                        {{ essay.essayStatus }}
                      </b-badge>
                      <b-badge
                        v-if="essay.accessContextLabel"
                        pill
                        :variant="essay.accessContextLabel === 'Centro' ? 'secondary' : 'success'"
                        class="font-size-11 mt-1"
                      >
                        {{ essay.accessContextLabel }}
                      </b-badge>
                    </div>
                  </div>

                  <!-- Project Name -->
                  <div class="mb-3">
                    <div class="d-flex align-items-center">
                      <i
                        class="ri-file-list-line text-muted mr-2"
                        v-b-tooltip.hover
                        title="Convocatoria"
                      ></i>
                      <span class="text-muted small">{{ essay.projectName }}</span>
                    </div>
                  </div>

                  <!-- Essay Info -->
                  <div class="essay-info mb-3">
                    <div class="info-item mb-2">
                      <i
                        class="ri-user-line text-muted mr-2"
                        v-b-tooltip.hover
                        title="Usuario creador"
                      ></i>
                      <span class="text-muted small">{{ essay.createdBy }}</span>
                    </div>
                    <div class="info-item mb-2">
                      <i
                        class="ri-calendar-line text-muted mr-2"
                        v-b-tooltip.hover
                        title="Fecha de creación"
                      ></i>
                      <span class="text-muted small">{{
                        formatDate(essay.created_at)
                      }}</span>
                    </div>
                  </div>

                  <!-- Type and Step Status with Labels -->
                  <div class="essay-metadata">
                    <div class="metadata-item mb-2">
                      <span class="metadata-label">Tipo de proyecto:</span>
                      <b-badge
                        pill
                        :variant="essay.type === 'new' ? 'primary' : 'info'"
                        class="font-size-11"
                      >
                        {{
                          statusHelper.getStatus({
                            itemStatus: essay.type,
                            type: "essayType",
                          })
                        }}
                      </b-badge>
                    </div>
                    <div class="metadata-item mb-2">
                      <span class="metadata-label">Estado de redacción:</span>
                      <b-badge
                        pill
                        :variant="getStepVariant(essay.current_step)"
                        class="font-size-11"
                      >
                        {{ getStepText(essay.current_step) }}
                      </b-badge>
                    </div>
                  </div>
                </div>

                <!-- Footer: Actions -->
                <div class="card-footer bg-transparent border-top pt-3 pb-3">
                  <div
                    v-if="isCenterCollaborator(essay) && isEssayInDraft(essay)"
                    class="center-tracking-pending"
                  >
                    <div class="d-flex align-items-start">
                      <i class="mdi mdi-clock-outline font-size-18 text-warning mr-2 mt-0"></i>
                      <div>
                        <div class="font-weight-medium text-dark mb-1">
                          Seguimiento no disponible
                        </div>
                        <div class="text-muted small mb-0">
                          El proyecto aún está en redacción. Podrás acceder cuando
                          deje de estar en este estado.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="essay-actions d-flex gap-2">
                    <button
                      v-if="
                        essay?.access?.context === 'owner' &&
                        (showElement(
                          [3],
                          essay?.current_step != 3,
                          essay?.essay_status_id != 3
                        ) ||
                        showElement(
                          [3],
                          essay?.current_step == 3,
                          essay?.essay_status_id == 3
                        ))
                      "
                      @click="editEssay(essay)"
                      class="btn btn-sm btn-outline-warning flex-fill"
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                      <span class="ml-1">Editar</span>
                    </button>
                    <router-link
                      v-if="
                        canCenterCollaboratorOpenEssay(essay) ||
                        (!isCenterCollaborator(essay) &&
                          showElement(
                            [1, 3],
                            essay?.current_step == 3,
                            essay?.essay_status_id != 3
                          ))
                      "
                      :to="{
                        name: 'essay-detail',
                        params: {
                          id: essay.project_id,
                          essayId: essay.id,
                        },
                      }"
                      class="btn btn-sm btn-outline-success flex-fill"
                    >
                      <i class="mdi mdi-eye-outline"></i>
                      <span class="ml-1">Ver</span>
                    </router-link>
                    <button
                      v-if="showElement([1])"
                      @click="toggleDelete(essay.id)"
                      class="btn btn-sm btn-outline-danger"
                    >
                      <i class="fas fa-trash"></i>
                      <span class="ml-1">Eliminar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="row mt-4" v-if="totalPages > 1">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="filteredEssays.length"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.essay-card {
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
}

.essay-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  border-color: #34c38f;
}

.essay-card .card-body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.essay-title {
  color: #495057;
  font-weight: 600;
  font-size: 1.1rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  cursor: help;
  line-height: 1.4;
}

.essay-info .info-item {
  display: flex;
  align-items: center;
}

.essay-metadata {
  margin-top: 1rem;
}

.metadata-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.metadata-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
  margin-right: 0.5rem;
  white-space: nowrap;
}

.essay-card .card-footer {
  margin-top: auto;
  padding: 1rem 1.25rem;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.essay-actions {
  display: flex;
  gap: 0.5rem;
}

.center-tracking-pending {
  background: #fff8e6;
  border: 1px solid #ffe8a3;
  border-radius: 0.35rem;
  padding: 0.75rem 0.9rem;
}

.essay-actions .btn {
  transition: all 0.2s ease;
  white-space: nowrap;
}

.essay-actions .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.essay-actions .btn-outline-warning {
  color: #e67e22;
  border-color: #e67e22;
}

.essay-actions .btn-outline-warning:hover {
  color: #fff;
  background-color: #e67e22;
  border-color: #e67e22;
}

.essay-actions .btn i {
  font-size: 1rem;
}

.search-box .search-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 18px;
  pointer-events: none;
  z-index: 1;
}

.search-box input {
  padding-right: 45px;
}

@media (max-width: 768px) {
  .essay-card {
    margin-bottom: 1rem;
  }
  
  .essay-actions .btn span {
    font-size: 0.75rem;
  }
  
  .metadata-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .metadata-label {
    margin-bottom: 0.25rem;
    margin-right: 0;
  }
}
</style>
